"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.mutatorAction('discardRegionalOption', function discardRegionalOption() {
    var optionState = store_1.default();
    optionState.selectedLocale = null;
    optionState.shouldRenameDefaultFolders = true;
    optionState.selectedDateFormat = null;
    optionState.selectedTimeFormat = null;
    optionState.selectedTimeZone = null;
});
//# sourceMappingURL=discardRegionalOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-regional-option/lib/data/mutators/discardRegionalOption.js
// module id = 4945
// module chunks = 2